module.exports = __webpack_public_path__ + "img/T007_Shopping.4f3eb063.png";